import { configureStore } from '@reduxjs/toolkit';
import pdfReducer from '../slices/pdfSlice';
import draftReducer from '../slices/draftSlice';
import manualReducer from '../slices/manualSlice';
import passwordReducer from '../slices/passwordSlice';
import notifReducer from '../slices/notifSlice';
import summaryReducer  from '../slices/summarySlice';
import clientReducer  from '../slices/clientSlice';
import logReducer  from '../slices/logSlice';
import projectReducer  from '../slices/projectSlice';
import dashReducer  from '../slices/dashSlice';
import productReducer  from '../slices/productSlice';
import helpdeskReducer  from '../slices/helpdeskSlice';
import transferReducer  from '../slices/transferSlice';
import engagementReducer  from '../slices/userEngagementSlice';
import adminOptionsReducer  from '../slices/adminOptionSlice';
import customerReducer  from '../slices/customerSlice';
import optionReducer  from '../slices/optionSlice';
import aiReducer from '../slices/aiSlice';
import drawerReducer from '../slices/drawerSlice';
import pdfDownloadsReducer from '../slices/pdfDownloadSlice';

export const store = configureStore({
    reducer: {
        pdfImages: pdfReducer,
        draft: draftReducer,
        manual: manualReducer,
        password: passwordReducer,
        notif: notifReducer,
        summary: summaryReducer,
        client: clientReducer,
        logs: logReducer,
        projects: projectReducer,
        dash: dashReducer,
        product: productReducer,
        helpdesk: helpdeskReducer,
        transfer: transferReducer,
        engagement: engagementReducer,
        adminOption: adminOptionsReducer,
        customer: customerReducer,
        options: optionReducer,
        ai: aiReducer,
        drawer: drawerReducer,
        pdfDownloads: pdfDownloadsReducer,
    },
});
